<script>
import jrQrcode from 'jr-qrcode'
import { getAgoraToken, getMiniAppAccessToken } from '@/apis/agora.api'
import { mapState } from 'vuex'
import CellPhonePreviewModal from './CellPhonePreviewModal.vue'
import AgoraRTC from 'agora-rtc-sdk-ng'
import { getExamId } from '@/utils'
export default {
  components: {
    CellPhonePreviewModal
  },
  data: () => ({
    qrcode: '',
    rtcClient: null,
    imageLoading: true
  }),
  computed: {
    ...mapState(['user', 'site_msg'])
  },
  mounted() {
    this.joinDetectChannel()
      .then(async () => {
        this.generateQrCode()
      })
      .catch(() => {
        this.$message.error('加入检测频道失败')
        this.imageLoading = false
        this.$emit('cell-phone-fail')
      })
  },
  methods: {
    async joinDetectChannel() {
      const client = (this.rtcClient = AgoraRTC.createClient({
        mode: 'rtc',
        codec: 'h264'
      }))

      const data = await getAgoraToken({
        userId: this.user.id,
        examId: getExamId(),
        type: 2,
        TIME: new Date().getTime()
      })

      client.on('user-published', async (user, mediaType) => {
        await client.subscribe(user, mediaType)
        if (mediaType === 'video') {
          this.$refs.previewRef.open(user.videoTrack)
        }
      })

      await client.join(data.appId, data.channel, data.token, data.uid)

      return {
        channel: data.channel,
        appId: data.appId
      }
    },
    async generateQrCode() {
      this.imageLoading = true
      const { key } = await getMiniAppAccessToken(
        // 小程序appId
        'wxe4db96436318d03f',
        getExamId()
      )

      const miniUrl = `${window.location.protocol}//${window.location.host}/proctoring-mini?key=${key}`

      const qrcode = jrQrcode.getQrBase64(miniUrl)
      this.qrcode = qrcode
      this.imageLoading = false
    },
    async handlePreviewPass() {
      await this.rtcClient.leave()
      this.$emit('cell-phone-pass')
    }
  }
}
</script>

<template>
  <div class="config-cell-phone-wrapper">
    <div class="scan-qr">
      <div class="guilde-text-wrapper">
        <p>请使用手机扫码，进行摄像头检测</p>
      </div>

      <div class="qrcode-box" v-if="!imageLoading">
        <img :src="qrcode" class="qr-code-img" />
        <span class="renew-icon" @click="generateQrCode"></span>
      </div>
      <div v-else class="qrcode-box">
        <span class="line-md--loading-alt-loop"></span>
      </div>
      <div>
        <button @click="generateQrCode" class="refresh-button" :class="{ 'loading': imageLoading }">刷新二维码</button>
      </div>

    </div>
    <CellPhonePreviewModal
      @preview-pass="handlePreviewPass"
      @quit="generateQrCode"
      ref="previewRef"
    />
  </div>
</template>
<style lang="scss" scoped>
.config-cell-phone-wrapper {
  margin-left: 70px;
  flex: 1;
}

.qr-code-img {
  width: 144px;
  height: 144px;
  margin: auto;
  position: relative;
}

.line-md--loading-alt-loop {
  display: inline-block;
  width: 40px;
  height: 40px;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  --svg: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24'%3E%3Cg fill='%23000'%3E%3Ccircle cx='12' cy='3.5' r='1.5'%3E%3CanimateTransform attributeName='transform' calcMode='discrete' dur='2.4s' repeatCount='indefinite' type='rotate' values='0 12 12;90 12 12;180 12 12;270 12 12'/%3E%3Canimate attributeName='opacity' dur='0.6s' repeatCount='indefinite' values='1;1;0'/%3E%3C/circle%3E%3Ccircle cx='12' cy='3.5' r='1.5' transform='rotate(30 12 12)'%3E%3CanimateTransform attributeName='transform' begin='0.2s' calcMode='discrete' dur='2.4s' repeatCount='indefinite' type='rotate' values='30 12 12;120 12 12;210 12 12;300 12 12'/%3E%3Canimate attributeName='opacity' begin='0.2s' dur='0.6s' repeatCount='indefinite' values='1;1;0'/%3E%3C/circle%3E%3Ccircle cx='12' cy='3.5' r='1.5' transform='rotate(60 12 12)'%3E%3CanimateTransform attributeName='transform' begin='0.4s' calcMode='discrete' dur='2.4s' repeatCount='indefinite' type='rotate' values='60 12 12;150 12 12;240 12 12;330 12 12'/%3E%3Canimate attributeName='opacity' begin='0.4s' dur='0.6s' repeatCount='indefinite' values='1;1;0'/%3E%3C/circle%3E%3C/g%3E%3C/svg%3E");
  background-color: currentColor;
  -webkit-mask-image: var(--svg);
  mask-image: var(--svg);
  -webkit-mask-repeat: no-repeat;
  mask-repeat: no-repeat;
  -webkit-mask-size: 100% 100%;
  mask-size: 100% 100%;
}

.qrcode-box {
  position: relative;
  margin: auto;
  margin-top: 24px;
  width: 144px;
  height: 144px;
  .renew-icon {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    background: #ffffff;
    border-radius: 3px;
    width: 24px;
    height: 24px;
    cursor: pointer;
    overflow: hidden;
  }
  .renew-icon::after {
    content: '';
    display: block;
    width: 24px;
    height: 24px;
    --svg: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24'%3E%3Cpath fill='%23000' d='M12.077 19q-2.931 0-4.966-2.033q-2.034-2.034-2.034-4.964t2.034-4.966T12.077 5q1.783 0 3.339.847q1.555.847 2.507 2.365V5.5q0-.213.144-.356T18.424 5t.356.144t.143.356v3.923q0 .343-.232.576t-.576.232h-3.923q-.212 0-.356-.144t-.144-.357t.144-.356t.356-.143h3.2q-.78-1.496-2.197-2.364Q13.78 6 12.077 6q-2.5 0-4.25 1.75T6.077 12t1.75 4.25t4.25 1.75q1.787 0 3.271-.968q1.485-.969 2.202-2.573q.085-.196.274-.275q.19-.08.388-.013q.211.067.28.275t-.015.404q-.833 1.885-2.56 3.017T12.077 19'/%3E%3C/svg%3E");
    background-color: currentColor;
    -webkit-mask-image: var(--svg);
    mask-image: var(--svg);
    -webkit-mask-repeat: no-repeat;
    mask-repeat: no-repeat;
    -webkit-mask-size: 100% 100%;
    mask-size: 100% 100%;
  }
}

.refresh-button {
  padding: 6px 16px;
  font-size: 14px;
  border-radius: 4px;
  border: 1px solid #409EFF;
  background: #409EFF;
  color: #fff;
  cursor: pointer;
  margin-top: 8px;
  &.loading {
    pointer-events: none;
    background-color: rgba(0, 0, 0, 0.5);
  }
}
</style>
